import { useEffect, useState } from 'react';
import { Tiers } from '../constants/prices';
import { limits, Product } from '../constants/defaults';
import { getListPrice } from 'src/common/hooks/widgets/fetchData';

export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}

const partNumber = {
  turbo: 'D09ECZX',
  SaaS: 'D09ECZX',
  Software: 'D28FALL',
};

type typeOfPart = {
  qty: number;
  price: number;
};
//Function to get rigth part number
const getPartToQuery = (productToAcquire: string) => {
  return productToAcquire === 'SaaS'
    ? [{ partNumber: partNumber.SaaS }]
    : [{ partNumber: partNumber.Software }];
};

export const partsToQuery = [
  {
    partNumber: partNumber.turbo,
  },
];

export const setPrice = (
  cloudInstances: number,
  onPremVMs: number,
  setShowContactUs: React.Dispatch<React.SetStateAction<boolean>>,
  setoneYearPriceMin: React.Dispatch<React.SetStateAction<number>>,
  productToAcquire: string,
  currency: string,
  country: string,
  userLocale: string,
) => {
  // Check language and prices
  const [priceFile, setPriceFile] = useState({} as priceProps[]);
  useEffect(() => {
    const body: any = {
      currency: currency,
      countryCode3: country,
      parts: getPartToQuery(productToAcquire),
    };
    if (currency.length === 0 || country.length === 0) {
      setPriceFile([]);
      return;
    }
    getListPrice(
      `https://api.marketplace.ibm.com/purchase/catalog/resources/price/info`,
      body,
      'POST',
    ).then((data) => {
      if (data.parts && data.parts.length !== 0) setPriceFile(data.parts);
      else {
        setPriceFile([]);
      }
    });
  }, [userLocale, currency, country, productToAcquire]);

  /**
   *
   */
  useEffect(() => {
    //We store total of On+Prem VMs for use in the ROI estimator
    if (
      cloudInstances + onPremVMs < limits.min ||
      cloudInstances + onPremVMs >= limits.max
    ) {
      setShowContactUs(true);
      setoneYearPriceMin(0);
    } else {
      const tier = determine_tier(cloudInstances + onPremVMs);
      //
      const price = determine_price(
        tier,
        cloudInstances + onPremVMs,
        productToAcquire,
        priceFile,
      );
      if (priceFile.length === 0 || price <= 0) {
        setShowContactUs(true);
      } else {
        setoneYearPriceMin(price);
        setShowContactUs(false);
      }
    }
  }, [cloudInstances, onPremVMs, productToAcquire, priceFile]);

  /**
   *
   * @param {*} value
   * @returns
   */
  const determine_tier = (value: number) => {
    let tier = '';
    if (value >= Tiers[0].min && value <= Tiers[0].max) tier = Tiers[0].tier;
    if (value >= Tiers[1].min && value <= Tiers[1].max) tier = Tiers[1].tier;
    if (value >= Tiers[2].min && value <= Tiers[2].max) tier = Tiers[2].tier;
    if (value >= Tiers[3].min && value <= Tiers[3].max) tier = Tiers[3].tier;
    return tier;
  };

  /**
   *
   * @param {*} tier
   * @param {*} quantity
   * @param {*} product
   * @returns
   */
  const determine_price = (
    tier: string,
    quantity: number,
    product: string,
    priceFile: priceProps[],
  ) => {
    let price = 0;
    let skipDiscount = true;
    let amountLeft = quantity;
    const prop = product === Product.SaaS ? Product.SaaS : Product.Software;
    const partToFind =
      product === Product.SaaS ? partNumber.SaaS : partNumber.Software;
    Object.keys(Tiers).forEach((value, index) => {
      if (tier === Tiers[index].tier && skipDiscount) skipDiscount = false;
      if (!skipDiscount) {
        let amountToProcess = amountLeft;
        if (Tiers[index].max > amountLeft) {
          amountToProcess = amountLeft - Tiers[index].min;
          amountLeft = Tiers[index].min;
        } else {
          amountToProcess = Tiers[index].max - Tiers[index].min;
          amountLeft = Tiers[index].min;
        }
        let tierPrice = 0;
        let value = {} as typeOfPart | undefined;
        // Find product
        if (priceFile?.length) {
          const turboPrice = priceFile.find((i) => i.partNumber == partToFind);
          if (turboPrice) {
            value = turboPrice.scaleQtyPrice.find((i) => i.qty == 1);
            if (value) {
              tierPrice = Math.round(
                value?.price * amountToProcess * (1 - Tiers[index][prop]),
              );
            }
          }
        }
        price += tierPrice;
      }
    });
    return price;
  };
};
